"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = locale;
var ALLOWED_LOCALES = ['en', 'ja'];

function locale(value) {
  return ALLOWED_LOCALES.includes(value);
}